var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsDetailRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.879425 16.001C0.706127 16.0001 0.536947 15.948 0.393104 15.8514C0.249261 15.7547 0.137158 15.6178 0.0708564 15.4576C0.00455448 15.2975 -0.0129951 15.1214 0.0204086 14.9513C0.0538123 14.7813 0.136682 14.6249 0.258625 14.5018L6.75862 8.00095L0.256225 1.50015C0.106965 1.33242 0.0274652 1.11398 0.0339993 0.889547C0.0405334 0.665115 0.132608 0.451668 0.291373 0.292903C0.450138 0.134138 0.663585 0.0420634 0.888017 0.0355293C1.11245 0.0289952 1.33089 0.108495 1.49862 0.257755L8.61862 7.37775C8.78277 7.54267 8.87492 7.76588 8.87492 7.99855C8.87492 8.23123 8.78277 8.45444 8.61862 8.61935L1.49862 15.7394C1.41775 15.8216 1.32141 15.8871 1.21514 15.932C1.10888 15.9769 0.994783 16.0003 0.879425 16.001",
    fill: "#525C6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsDetailRightArrow);
export default __webpack_public_path__ + "static/media/termsDetailRightArrow.9e2616a0e77b2008f32023cbbc9bc3fd.svg";
export { ForwardRef as ReactComponent };